export default __webpack_public_path__ + "static/media/h5-section1-bg3.98f5d29d.png";